import type { ScanRecord } from '../services/scanService';

/**
 * Get the display name for a scan
 * Returns custom name if provided, otherwise "Scan N" based on chronological order
 * @param scan - The scan record
 * @param scanNumber - Optional: The scan number (1-based, where 1 is the oldest scan)
 */
export function getScanDisplayName(scan: ScanRecord, scanNumber?: number): string {
  if (scan.customName && scan.customName.trim()) {
    return scan.customName.trim();
  }
  
  // Fallback: Use scan number if provided, otherwise "Scan"
  if (scanNumber !== undefined && scanNumber > 0) {
    return `Scan ${scanNumber}`;
  }
  
  // Last resort: return generic "Scan"
  return 'Scan';
}
